import { state } from 'cerebral'
import * as sequences from './sequences'
import apiClient from '../../lib/util/api-client'
import schemaSettings from '../../../shared/schemas/generic-type-schema'
import { createProviders } from '../providers'
import { redirectUnauthorized, createCrudState } from '../factories'
import { showFeedbackFromError } from '../feedback/factories'
import { expandEntities } from '../computed'

const { genericTypeSchema: schema } = schemaSettings
const service = apiClient.service('generic-types')

export const categoryKeys = {
  visitType: 'visit-type',
  behavior: 'behavior',
  trigger: 'trigger',
  intervention: 'intervention',
  outcome: 'outcome',
}

export const toCategoryOptions = (data = []) =>
  data.reduce(
    ({ categories, byValue }, { name, value: categoryValue, activity }) => {
      const category = activity?.category

      if (category && name) {
        const value = categoryValue || name

        const option = {
          value,
          label: name,
          group: activity?.group,
        }

        categories[category] = (categories[category] || []).concat(option)
        byValue[category] = { ...(byValue[category] || {}), [value]: option }
      }

      return { categories, byValue }
    },
    { categories: {}, byValue: {} }
  )

export const activityCategories = (entityType, storePrefix) => (get) => toCategoryOptions(expandEntities(entityType, state`${storePrefix}.list.ids`)(get))

export default ({ name }) => ({
  state: {
    ...createCrudState({ entityType: 'genericTypes', storePrefix: name }),
    activityCategories: activityCategories('genericTypes', name),
  },
  sequences,
  providers: createProviders({ name, service, schema }),
  catch: [
    redirectUnauthorized(),
    [
      Error,
      showFeedbackFromError({ title: 'We encountered an error' }),
      ({ props: { error, errorPath = name }, store }) => {
        store.set(state`errors.${errorPath}`, error)
      },
    ],
  ],
})
